/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestGetForEmployerAddressHeatmap } from '../model/models';
import { ApiResponseGetPossibleCommuteLatLongsByAssociatedAddress } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EmployerAddressSurveillanceServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param employerId 
     */
    employerAddressSurveillanceControllerAddUserWithEmail0(employerId: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param employerId 
     */
    employerAddressSurveillanceControllerAddUserWithEmail1(employerId: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestGetForEmployerAddressHeatmap 
     */
    employerAddressSurveillanceControllerGetPossibleCommuteLatLongsByAssociatedAddress0(apiRequestGetForEmployerAddressHeatmap: ApiRequestGetForEmployerAddressHeatmap, extraHttpRequestParams?: any): Observable<ApiResponseGetPossibleCommuteLatLongsByAssociatedAddress>;

    /**
     * 
     * 
     * @param apiRequestGetForEmployerAddressHeatmap 
     */
    employerAddressSurveillanceControllerGetPossibleCommuteLatLongsByAssociatedAddress1(apiRequestGetForEmployerAddressHeatmap: ApiRequestGetForEmployerAddressHeatmap, extraHttpRequestParams?: any): Observable<ApiResponseGetPossibleCommuteLatLongsByAssociatedAddress>;

}
